import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import dollar from "../../../assets/icons/dollar.svg";
import percentage from "../../../assets/icons/percentage.svg";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddClosedData = ({ isSidebarOpen, formData, disable, error, onSetFormData, onSetError, handleSubmit, handleClose, isDollar,
  setIsDollar, }) => {
  const [config] = useAuth();
  const [propertyOptions, setPropertyOptions] = useState([]);

  const handleChange = (value, name) => {
    onSetError({ ...error, [name]: "" });
    onSetFormData({ ...formData, [name]: value });
  };

  const fetchPropertySuggestions = (inputValue) => {
    const isPortfolio = formData?.portfolio === 1;
    axios
      .get(`${BASE_URL}/get-datalisting?list=under_contract&search=${inputValue}&portfolio=${isPortfolio ? 1 : 0}`, config)
      .then((res) => {
        const data = res.data.contract;
        const options = data.map((el) => ({
          value: el.id,
          label: `${el?.executed?.link?.property_name} (${el?.status_name})`,
          desc: `${el?.executed?.link?.street_address}, ${el?.executed?.link?.city}, ${el?.executed?.link?.state}`,
          under_contract_id: el.id,
          property: {
            id: el?.executed?.link?.id,
            name: el?.executed?.link?.property_name,
          },
        }));
        setPropertyOptions(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (isSidebarOpen) {
      fetchPropertySuggestions();
    }
  }, [isSidebarOpen]);

  const handlePortfolioChange = (value) => {
    const portfolioStatus = formData.portfolio ? 0 : 1;
    onSetFormData({ ...formData, portfolio: portfolioStatus, link: "" });
  };

  return (
    <form onSubmit={handleSubmit}>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2">Closing Date</label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          selected={
            formData.closing_date
              ? moment.tz(formData.closing_date, "America/New_York").toDate()
              : null
          }
          onChange={(value) => {
            // Convert selected date to New York timezone before saving
            const nyDate = moment(value).tz("America/New_York").format("YYYY-MM-DD");
            onSetError({ ...error, closing_date: "" });
            handleChange(nyDate, "closing_date");
          }}
        />
        {error?.closing_date && <p className="body-S red-D">{error?.closing_date}</p>}
      </div>

      <div className="mt-6">
        <label className="container" style={{ marginBottom: "0px" }}>
          <p style={{ paddingLeft: "30px" }} className="dark-H head-4">Portfolio</p>
          <input
            type="checkbox"
            checked={formData?.portfolio}
            className="body-N"
            onChange={(value) => {
              handlePortfolioChange(value);
            }}
          />
          <span className="checkmark"></span>
        </label>
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2">Property Name</label>
        <SearchDropdown
          placeholder="search Property here"
          text={formData?.property?.name}
          options={propertyOptions}
          fetchSuggestions={fetchPropertySuggestions}
          onSetOptions={(value) => setPropertyOptions(value)}
          handleSelect={(option) => {
            onSetFormData({ // Use onSetFormData instead of setFormData
              ...formData,
              under_contract_id: option?.value,
              property: { id: option?.value, name: option?.label },
            });
            setPropertyOptions([]);
          }}
        />
        {error?.property_name && <p className="body-S red-D pt-1">{error?.property_name}</p>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2">Sale Price</label>
        <InputWithIcon
          icon={dollar}
          className="body-N"
          name="contract_price"
          type="number"
          placeholder="Write Sale Price Here"
          value={formData.contract_price}
          onChange={(e) => handleChange(e.target.value, "contract_price")}
        />
        {error?.contract_price && <p className="body-S red-D pt-1">{error?.contract_price}</p>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2">Sale Cap Rate</label>
        <InputWithIcon
          icon={percentage}
          className="body-N"
          name="contract_cap_rate"
          type="number"
          placeholder="Write Sale Cap Rate Here"
          value={formData.contract_cap_rate}
          onChange={(e) => handleChange(e.target.value, "contract_cap_rate")}
        />
        {error?.contract_cap_rate && <p className="body-S red-D pt-1">{error?.contract_cap_rate}</p>}
      </div>
      <div className="mt-6">
        <div className="flex justify-between gap-2">
          <label className="dark-H head-4 mb-2">GCI To Company</label>
          <button
            type="button"
            onClick={() => setIsDollar(!isDollar)}
            className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
          >
            {isDollar ? "%" : "$"}
          </button>
        </div>
        <div>
          <InputWithIcon
            icon={isDollar ? dollar : percentage}
            className="body-N"
            name="company_gcl"
            type="number"
            placeholder={`Write GCI To Company `}
            value={formData.company_gcl}
            onChange={(e) => handleChange(e.target.value, "company_gcl")}
          />
        </div>
        {error?.company_gcl && <p className="body-S red-D pt-1">{error?.company_gcl}</p>}
      </div>

      <div className="mt-6 ">
        <label className="dark-H head-4 mb-2">Initial List Date</label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          selected={formData.initial_date ? new Date(formData.initial_date) : null} // Corrected initail_date to initial_date
          onChange={(value) => {
            onSetError({ ...error, initial_date: "" });
            handleChange(value, "initial_date"); // Corrected initail_date to initial_date
          }}
        />
        {error?.initial_date && <p className="body-S red-D">{error?.initial_date}</p>}
      </div>

      <div className="mt-6 ">
        <label className="dark-H head-4 mb-2">Contract Date</label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          selected={formData.contract_date ? new Date(formData.contract_date) : null}
          onChange={(value) => {
            onSetError({ ...error, contract_date: "" });
            handleChange(value, "contract_date");
          }}
        />
        {error?.contract_date && <p className="body-S red-D">{error?.contract_date}</p>}
      </div>

      <div className="mt-6">
        <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleClose} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddClosedData;